<script lang="ts">
    import { faTrash } from '@fortawesome/free-solid-svg-icons'
    import Zinput from '../_common/z/zinput.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import type { User } from '../../modules/usersApi/users/user'

    // superUser não é campo do usuário: é a permissão "super" do vínculo com a empresa, gravada numa
    // chamada à parte ao salvar (ver ob-users.svelte)
    export let user: User & { superUser?: boolean }
    // o próprio usuário logado não aparece com o toggle: em regra é o proprietário da empresa, e a
    // permissão dele não se ajusta aqui
    export let showSuper: boolean = true

    const help =
        'Super usuário: tem poderes ilimitados no Zandu, sem nenhuma restrição de permissão. Deixe desligado para um usuário comum.'

    function removeItem() {
        user = null
    }
</script>

{#if user}
    <ZContainer class="mt-2" gapRow="8px" gapCol="8px">
        <Zinput size={3} sizeM={12} label="Nome" type="text" bind:value={user.userName} />
        <Zinput size={3} sizeM={12} label="Celular" type="tel" bind:value={user.phone} />
        <Zinput size={3} sizeM={12} label="E-Mail (opcional)" type="text" bind:value={user.email} />
        {#if showSuper}
            <Zinput size={2} sizeM={12} label="Super" type="toggle" {help} bind:value={user.superUser} />
        {/if}
        <ZContainerCol size={1} sizeM={12}>
            {#if !user.userId}
                <Zbutton color="red" icon={faTrash} on:click={removeItem} />
            {/if}
        </ZContainerCol>
    </ZContainer>
{/if}
